// extracted by mini-css-extract-plugin
module.exports = {"title":"QupQl","text":"ssLOU","link":"k1PBL","iconWrapper":"KS9su","icon":"dT7h0","theme_more":"Y4dAt"};